import { KeyboardEvent, useCallback, useEffect, useState } from 'react'

type UseKeyboardOptions = {
  itemCount: number
  onReset: () => void
}

export function useKeyboard({ itemCount, onReset }: UseKeyboardOptions) {
  const [activeIndex, setActiveIndex] = useState(-1)

  useEffect(() => {
    setActiveIndex((previous) => {
      if (itemCount === 0) {
        return -1
      }

      if (previous < 0) {
        return 0
      }

      return Math.min(previous, itemCount - 1)
    })
  }, [itemCount])

  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          setActiveIndex((previous) => Math.min(previous + 1, itemCount - 1))
          break

        case 'ArrowUp':
          event.preventDefault()
          setActiveIndex((previous) => Math.max(previous - 1, 0))
          break

        case 'Home':
          event.preventDefault()
          setActiveIndex(0)
          break

        case 'End':
          event.preventDefault()
          setActiveIndex(itemCount - 1)
          break

        case 'PageDown':
          event.preventDefault()
          setActiveIndex((previous) => Math.min(previous + 10, itemCount - 1))
          break

        case 'PageUp':
          event.preventDefault()
          setActiveIndex((previous) => Math.max(previous - 10, 0))
          break

        case 'Escape':
          event.preventDefault()
          onReset()
          break

        case 'Tab':
          event.preventDefault()
          onReset()
          break
      }
    },
    [itemCount, onReset],
  )

  return {
    activeIndex,
    setActiveIndex,
    onKeyDown,
  }
}
